import { Routes, Route, Navigate } from 'react-router-dom'
import { Box, Container, Paper, Typography, CircularProgress } from '@mui/material'

import { useAuth } from './auth/useAuth'

// Landing Pages
import PublicLandingPage from './pages/PublicLandingPage/PublicLandingPage'
import InternalLandingPage from './pages/InternalLandingPage/InternalLandingPage'
import AdminDashboard from './pages/AdminDashboard/AdminDashboard'
import LandingConfigPage from './pages/LandingConfigPage/LandingConfigPage'

// Business Applications
import StrategicFundManagement from './pages/StrategicFundManagement/StrategicFundManagement'
import HedgeFundDatabase from './pages/HedgeFundDatabase/HedgeFundDatabase'

// Simple loading screen component
const LoadingScreen: React.FC = () => {
  return (
    <Box sx={{ 
      flexGrow: 1, 
      minHeight: '100vh', 
      backgroundColor: '#f8f9fa',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <Container maxWidth="sm">
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <CircularProgress size={60} sx={{ mb: 2 }} />
          <Typography variant="h6" color="text.secondary">
            Loading...
          </Typography>
        </Paper>
      </Container>
    </Box>
  )
}

function App() {
  const { isAuthenticated, isLoading, userPermissions } = useAuth()

  // Show loading screen while authentication is being determined
  if (isLoading) {
    return <LoadingScreen />
  }

  // Show public landing page if not authenticated
  if (!isAuthenticated) {
    return <PublicLandingPage />
  }

  return (
    <Routes>
      {/* Internal Landing Page - Main dashboard after authentication */}
      <Route path="/" element={<InternalLandingPage />} />
      
      {/* Business Applications */}
      <Route path="/strategic" element={<StrategicFundManagement />} />
      <Route path="/hedgefund" element={<HedgeFundDatabase />} />
      
      {/* Admin Routes */}
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/landing-config" element={<LandingConfigPage />} />
      
      {/* Redirect unknown routes to internal landing page */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
